export default "__VITE_ASSET__1rRumiZ$__"